import React, { useState, Fragment } from "react";
import "./_login.scss";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import Modal from "react-bootstrap/Modal";

import login from "../../Assets/Images/login.svg";
import modalClose from "../../Assets/Images/close.svg";
import { Spinner } from "react-bootstrap";

export default function BookDemo(props) {
  const [fname, setFname] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [comapny, setCompany] = useState("");
  const [designation, setDesignation] = useState("");
  const [msg, setMsg] = useState("N/A");
  const [mailerSubject, setMailerSubject] = useState("Popincx.com");
  const [errors, setErrors] = useState({});
  const [formPost, setformPost] = useState(false);
  const [loader, setLoader] = useState(false)
  const validateInputs = () => {
    const newErrors = {};
    if (!fname.trim()) newErrors.fname = "Name is required.";
    if (!email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Enter a valid email address.";
    }
    if (!mobile.trim() || mobile.length < 10) {
      newErrors.mobile = "Enter a valid mobile number.";
    }
    if (!comapny.trim()) newErrors.comapny = "Nature of business is required.";
    if (!designation.trim()) newErrors.designation = "Designation is required.";
    return newErrors;
  };

  const handleSubmit = () => {
    setLoader(true)
    const validationErrors = validateInputs();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const payload = {
      fname,
      designation,
      comapny,
      email,
      mobile,
      msg,
      mailerSubject,
    };

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(payload),
      redirect: "follow",
    };

    fetch("https://ndjs-zencecrm.easyrewardz.com/api/custom-email", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        setLoader(false)
        const parsedResult = JSON.parse(result);

        if (parsedResult?.errors) {
          const errorObject = parsedResult.errors.reduce((acc, error) => {
            if (error?.path === "email") {
              acc.email = "Please fill a correct email.";
            } else if (error?.path === "mobile") {
              acc.mobile = "Please fill a correct mobile number.";
            }
            return acc;
          }, {});
          setErrors(errorObject);
        } else {
          setformPost(true)
          setErrors({});
          setFname("");
          setEmail("");
          setMobile("");
          setCompany("");
          setDesignation("");
          setMsg("");
        }
      })
      .catch((error) => {
        console.error("Error during submission:", error);
      });
  };

  return (
    <Fragment>
      <Modal
        show={props.showModal}
        onHide={props.handleCloseModal}
        className="login-modal"
      >
        <div className="position-relative">
          <a onClick={props.handleCloseModal} className="close">
            <img src={modalClose} alt="close" />
          </a>
        </div>
        <Modal.Body>
          <div className="login-container">
            <div className="img-container col">
              <img src={login} alt="login" />
            </div>
            <div className="input-form col">
              <div className="text-center">
                <h4 className="login-heading">Get Started</h4>
                <p className="login-para">
                  Your first step towards business growth
                </p>
              </div>
              <div className="row">
                <div className="col-12 mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className={`form-control ${errors.fname ? "is-invalid" : ""}`}
                    placeholder="Enter your Name"
                    value={fname}
                    onChange={(e) => setFname(e.target.value)}
                  />
                  {errors.fname && <div className="invalid-feedback">{errors.fname}</div>}
                </div>
                <div className="col-12 mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className={`form-control ${errors.email ? "is-invalid" : ""}`}
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                </div>
                <div className="col-12 mb-3">
                  <label className="form-label">Mobile Number</label>
                  <PhoneInput
                    country={"in"}
                    value={mobile}
                    onChange={(phone) => setMobile(phone)}
                    containerClassName={errors.mobile ? "is-invalid" : ""}
                  />
                  {errors.mobile && <div className="invalid-feedback">{errors.mobile}</div>}
                </div>
                <div className="col-12 mb-3">
                  <label className="form-label">Nature of Business</label>
                  <input
                    type="text"
                    className={`form-control ${errors.comapny ? "is-invalid" : ""}`}
                    placeholder="Restaurant, Hospitality, Retail"
                    value={comapny}
                    onChange={(e) => setCompany(e.target.value)}
                  />
                  {errors.comapny && <div className="invalid-feedback">{errors.comapny}</div>}
                </div>
                <div className="col-12 mb-3">
                  <label className="form-label"> Number of Store</label>
                  <input
                    type="text"
                    className={`form-control ${errors.designation ? "is-invalid" : ""}`}
                    placeholder="Store"
                    value={designation}
                    onChange={(e) => setDesignation(e.target.value)}
                  />
                  {errors.designation && <div className="invalid-feedback">{errors.designation}</div>}
                </div>

                <div className="col-12 mb-2 mt-1">
                  <button className="btn btn-submit" onClick={handleSubmit}>
                    {loader ? <Spinner color="light">
                    </Spinner> : "Submit"}
                  </button>
                  {formPost && <p className="text-success"><br/> Thank you. We will soon get back to you.</p>}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}
